package io.horion.auth.presentation.ui.theme

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.px

data class AuthColors(
    val primary: Color,
    val onPrimary: Color,
    val secondary: Color,
    val background: Color,
    val onBackground: Color,
    val surface: Color,
    val onSurface: Color,
    val inputBg: Color,
    val black: Color,
    val border: Color,
    val borderLight: Color,
    val cardBg: Color,
    val success: Color,
    val error: Color,
    val warning: Color,
    val mutedText: Color,
    //sidebar
    val sidebarBg: Color,
    val sidebarBorder: Color,
    val sidebarActiveItem: Color,
    val sidebarActivePrimary: Color,
    //badges
    val badgeRoleBg: Color,
    val badgeRoleText: Color,
    val badgeActiveBg: Color,
    val badgeActiveText: Color,
)

object AuthTheme {
    val light = AuthColors(
        primary             = Color.rgb(0x003366),
        onPrimary           = Colors.White,
        secondary           = Color.rgb(0x6B7280),
        background          = Color.rgb(0xF9F9FF),
        onBackground        = Color.rgb(0x111827),
        surface             = Colors.White,
        onSurface           = Color.rgb(0x111827),
        inputBg             = Color.rgb(0xF3F4F6),
        black               = Colors.Black,
        border              = Color.rgb(0xE5E7EB),
        borderLight         = Color.rgba(0, 51, 102, 26),
        cardBg              = Color.rgba(255, 255, 255, 242),
        success             = Color.rgb(0x10B981),
        error               = Color.rgb(0xEF4444),
        warning             = Color.rgb(0xF59E0B),
        mutedText           = Color.rgb(0x6B7280),
        sidebarBg           = Colors.White,
        sidebarBorder       = Color.rgb(0xF3F4F6),
        sidebarActiveItem   = Color.rgb(0xEEF2FF),
        sidebarActivePrimary = Color.rgb(0x003366),
        // Badges light
        badgeRoleBg          = Color.rgb(0xEEF2FF),
        badgeRoleText        = Color.rgb(0x003366),
        badgeActiveBg        = Color.rgba(16, 185, 129, 30),
        badgeActiveText      = Color.rgb(0x10B981),
    )

    val dark = AuthColors(
        primary             = Color.rgb(0x4A9EFF),
        onPrimary           = Colors.White,
        secondary           = Color.rgb(0x9CA3AF),
        background          = Color.rgb(0x06080B),
        onBackground        = Colors.White,
        surface             = Color.rgb(0x13171F),
        onSurface           = Colors.White,
        inputBg             = Color.rgba(255, 255, 255, 13),
        black               = Colors.Black,
        border              = Color.rgba(255, 255, 255, 31),
        borderLight         = Color.rgba(255, 255, 255, 15),
        cardBg              = Color.rgba(19, 23, 31, 250),
        success             = Color.rgb(0x10B981),
        error               = Color.rgb(0xEF4444),
        warning             = Color.rgb(0xF59E0B),
        mutedText           = Color.rgb(0x9CA3AF),
        sidebarBg           = Color.rgb(0x0D1117),
        sidebarBorder       = Color.rgba(255, 255, 255, 13),
        sidebarActiveItem   = Color.rgba(74, 158, 255, 25),
        sidebarActivePrimary = Color.rgb(0x4A9EFF),
        // Badges dark
        badgeRoleBg          = Color.rgba(74, 158, 255, 25),
        badgeRoleText        = Color.rgb(0x4A9EFF),
        badgeActiveBg        = Color.rgba(16, 185, 129, 25),
        badgeActiveText      = Color.rgb(0x10B981),
    )

    fun colors(mode: ColorMode): AuthColors = if (mode.isLight) light else dark
}

object AuthSpacing {
    val xs  = 4.px
    val sm  = 8.px
    val md  = 16.px
    val lg  = 24.px
    val xl  = 32.px
    val xxl = 48.px
}

object AuthTypography {
    val h1    = 32.px
    val h2    = 24.px
    val h3    = 20.px
    val body  = 16.px
    val small = 14.px
    val tiny  = 12.px
}